export default __webpack_public_path__ + "static/media/close.3e4d14f7.svg";